import React from 'react';
import { useSelector } from 'react-redux';

// Modules
import SearchHeroModule from '../../modules/SearchHeroModule';
import UpsellModule from '../../modules/UpsellModule';
import { TenantPlacementPromoModule } from '@zg-rentals/zrm-marketing-components';

// Components
import PageHead from './PageHead';
import StaticCommonQuestions from './../../components/StaticCommonQuestions';

// Styles
import * as S from './styles';

// Constants
import StringConstants from '../../constants/StringConstants';

// Types
import type { State } from '../../types/State';

const PriceMyRentalPage = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname);

  return (
    <>
      <PageHead canonicalURL={`${StringConstants.ZILLOW_URL}${pathname}`} />
      <S.PriceMyRentalPage>
        <S.ContentSection noPaddingOrShadow>
          <SearchHeroModule />
        </S.ContentSection>
        <S.ContentSection noPaddingOrShadow>
          <TenantPlacementPromoModule />
        </S.ContentSection>
        <S.ContentSection>
          <UpsellModule />
        </S.ContentSection>
        <S.ContentSection>
          <StaticCommonQuestions />
        </S.ContentSection>
      </S.PriceMyRentalPage>
    </>
  );
};

export default PriceMyRentalPage;
